import { Injectable } from '@angular/core';
import { param } from '@app/model/paramobj';
import { I18nService } from '@app/core';
import { Http } from '@angular/http';
import { ApiService } from './api.service';
import { environment } from '@env/environment';
declare var $: any;
@Injectable()
export class UtilService {
    [x: string]: any;

    constructor(

        private i18nService: I18nService,
        private http: Http
    ) { }

    ConfirmDialog(msg: string) {
        $('#lblMainConfirmMessage').html(msg);
        $('#dlgMainConfirm').modal({
            backdrop: 'static',
            keyboard: false
        });
    }
    SuccessDialog(msg: string) {
        $('#lblMainSuccess').html(msg);
        $('#dlgMainSuccess').modal({
            backdrop: 'static',
            keyboard: false
        });
    }
    ErrorDialog(msg: string) {
        $('#lblMainError').html(msg);
        $('#dlgMainError').modal({
            backdrop: 'static',
            keyboard: false
        });
    }
    WarningDialog(msg: string) {
        //msg = 'Please specify' + ' ' + msg;
        $('#lblMainWarning').html(msg);
        $('#dlgMainWarning').modal({
            backdrop: 'static',
            keyboard: false
        });
    }
    ValidateForm(divId?: string) {
        var check = 0;
        var target = 'div#divMainTemplate'
        if (divId != null) {
            target = target + ' ' + divId;
        }

        $(target).find('input,select,textarea').each(function () {
            if ($(this).prop('required')) {
                $(this).on("change paste keyup", function () {
                    if ($(this).val() != null || $(this).val() != '') {
                        $(this).removeClass("requiredvalid");
                    }
                });
                if ($(this).val() == null || $(this).val() == '') {
                    if (check == 0) {
                        $(this).focus();
                    }
                    $(this).addClass("requiredvalid");
                    check++;
                } else {
                    $(this).removeClass("requiredvalid");
                }
            }
        });
        if (check == 0) {
            return true;
        } else {
            this.ErrorDialog('กรุณากรอกค่าให้ครบถ้วน');
            return false;
        }
    }

    ClearObj(obj: any) {
        for (let prop in obj) {
            obj[prop] = null;
        }
        return obj;
    }

    InitPermiss() {
        const objSessionCurrent = JSON.parse(sessionStorage.getItem('current_page_permiss'));
        if (objSessionCurrent != null) {
            if (objSessionCurrent.add_status == 1) {
                $('[role=add]').removeAttr('disabled');
                $('[role=add]').css('cursor', 'pointer');
            } else {
                $('[role=add]').attr('disabled', 'disabled');
                $('[role=add]').css('cursor', 'not-allowed');
            }
            if (objSessionCurrent.edit_status == 1) {
                $('[role=edit]').removeAttr('disabled');
                $('[role=edit]').css('cursor', 'pointer');
            } else {
                $('[role=edit]').attr('disabled', 'disabled');
                $('[role=edit]').css('cursor', 'not-allowed');
            }
            if (objSessionCurrent.delete_status == 1) {
                $('[role=delete]').removeAttr('disabled');
                $('[role=delete]').css('cursor', 'pointer');
            } else {
                $('[role=delete]').attr('disabled', 'disabled');
                $('[role=delete]').css('cursor', 'not-allowed');
            }
            if (objSessionCurrent.view_status == 1) {
                $('[role=view]').removeAttr('disabled');
                $('[role=view]').css('cursor', 'pointer');
            } else {
                $('[role=view]').attr('disabled', 'disabled');
                $('[role=view]').css('cursor', 'not-allowed');
            }
            if (objSessionCurrent.print_status == 1) {
                $('[role=print]').removeAttr('disabled');
                $('[role=print]').css('cursor', 'pointer');
            } else {
                $('[role=print]').attr('disabled', 'disabled');
                $('[role=print]').css('cursor', 'not-allowed');
            }
            if (objSessionCurrent.save_status == 1) {
                $('[role=save]').removeAttr('disabled');
                $('[role=save]').css('cursor', 'pointer');
            } else {
                $('[role=save]').attr('disabled', 'disabled');
                $('[role=save]').css('cursor', 'not-allowed');
            }
        }
    }
    InitValidation() {
        this.Validate_DatatypeInt('number');
        this.Validate_TextThaiOnly('txtThai');
        this.Validate_TextEngOnly('txtEng');

    }

    Validate_DatatypeInt(targetClass: string) {
        $('.' + targetClass).on('keydown', function (e: any) {
            if (e.keyCode != 8 //backspace
                && e.keyCode != 9 //tap
                && e.keyCode != 46 //delete
                && e.keyCode != 37 //arrow left
                && e.keyCode != 39 //arrow right
                && !((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) //not number
                //&& e.key.match(/[0-9]/g) == null
            ) {
                e.preventDefault();
            }
        });

        $('.' + targetClass).on('input', function (e: any) {
            if (this.value != "") {
                if (this.value.replace(/[^0-9]+/g, "") == "") {
                    this.value = "";
                }

            }
        });

        $('.' + targetClass).on('change', function () {
            if (this.value.replace(/[^0-9]+/g, "") == "") {
                this.value = "";
            } else {
                this.value = this.value.replace(/[^0-9]+/g, "");

            }
        });
    }

    Validate_DatatypeIntTimeHHmm(targetClass: string) {
        $('.' + targetClass).on('keydown', function (e: any) {
            if (e.keyCode != 8 //backspace
                && e.keyCode != 9 //tap
                && e.keyCode != 46 //delete
                && e.keyCode != 37 //arrow left
                && e.keyCode != 39 //arrow right
                && !((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) //not number
                //&& e.key.match(/[0-9]/g) == null
            ) {
                e.preventDefault();
            }
            if (this.value.length >= 2) {
                //this.value = this.value.replace(/[^0-9]+/g, "");
                this.value = "";
            }
        });

        $('.' + targetClass).on('input', function (e: any) {
            if (this.value != "") {
                if (this.value.replace(/[^0-9]+/g, "") == "") {
                    this.value = "";

                }

            }
        });

        $('.' + targetClass).on('change', function () {
            if (this.value.replace(/[^0-9]+/g, "") == "") {
                this.value = "";
            } else {
                this.value = this.value.replace(/[^0-9]+/g, "");
            }
        });
    }

    Validate_TextThaiOnly(targetClass: string) {
        $('.' + targetClass).on('keydown', function (e: any) {
            if (e != undefined) {
                if (e.key.match(/^[ก-๋์.-]+$/g) == null //not thai language
                    && e.keyCode != 32 //not spece bar
                    && e.keyCode != 8 //backspace
                    && e.keyCode != 9 //ta
                    && e.keyCode != 46 //delete
                    && e.keyCode != 37 //arrow left
                    && e.keyCode != 39 //arrow right
                ) {
                    e.preventDefault();
                }
            }
        });

        $('.' + targetClass).on('change', function () {
            if (this.value != "") {
                // if (!this.value.match(/(^[^๑-๙]+[ก-๋์]+\s?[ก-๋์*]+$)+/g))
                if (!this.value.match(/^([ก-๋์.-]\s?([ก-๋์.-])*)*$/g))
                    this.value = "";
            }
            this.value = this.value.replace(/([&!฿"^])*/g, "");
        });
    }

    Validate_TextEngOnly(targetClass: string) {
        $('.' + targetClass).on('keydown', function (e: any) {
            if (e.key.match(/^[a-zA-Z.-]+$/g) == null //not thai language
                && e.keyCode != 32 //not spece bar
                && e.keyCode != 8 //backspace
                && e.keyCode != 9 //tap
                && e.keyCode != 46 //delete
                && e.keyCode != 37 //arrow left
                && e.keyCode != 39 //arrow right
            ) {
                e.preventDefault();
            }
        });

        $('.' + targetClass).on('change', function () {
            if (this.value != "") {
                if (!this.value.match(/^([a-zA-Z.-]\s?([a-zA-z.-])*)*$/g))
                    this.value = "";
            }

        });
    }

    GetClientIP() {
        // var _window = (window as any);
        // // NOTE: window.RTCPeerConnection is "not a constructor" in FF22/23
        // var RTCPeerConnection = /*window.RTCPeerConnection ||*/ _window.webkitRTCPeerConnection || _window.mozRTCPeerConnection;

        // if (RTCPeerConnection) (function () {
        //     var rtc = new RTCPeerConnection({ iceServers: [] });
        //     if (1 || _window.mozRTCPeerConnection) {      // FF [and now Chrome!] needs a channel/stream to proceed
        //         rtc.createDataChannel('', { reliable: false });
        //     };

        //     rtc.onicecandidate = function (evt: any) {
        //         // convert the candidate to SDP so we can run it through our general parser
        //         // see https://twitter.com/lancestout/status/525796175425720320 for details
        //         if (evt.candidate) grepSDP("a=" + evt.candidate.candidate);
        //     };
        //     rtc.createOffer(function (offerDesc: any) {
        //         grepSDP(offerDesc.sdp);
        //         rtc.setLocalDescription(offerDesc);
        //     }, function (e: any) { console.warn("offer failed", e); });


        //     var addrs = Object.create(null);
        //     addrs["0.0.0.0"] = false;
        //     function updateDisplay(newAddr: any) {
        //         if (newAddr in addrs) return;
        //         else addrs[newAddr] = true;
        //         var displayAddrs = Object.keys(addrs).filter(function (k) { return addrs[k]; });

        //         var ip = displayAddrs[0];//.join(" or perhaps ") || "n/a";
        //         sessionStorage.setItem("clientIP", ip);
        //         //document.getElementById('list').textContent = displayAddrs.join(" or perhaps ") || "n/a";
        //     }

        //     function grepSDP(sdp: any) {
        //         var hosts = [];
        //         sdp.split('\r\n').forEach(function (line: any) { // c.f. http://tools.ietf.org/html/rfc4566#page-39
        //             if (~line.indexOf("a=candidate")) {     // http://tools.ietf.org/html/rfc4566#section-5.13
        //                 var parts = line.split(' '),        // http://tools.ietf.org/html/rfc5245#section-15.1
        //                     addr = parts[4],
        //                     type = parts[7];
        //                 if (type === 'host') updateDisplay(addr);
        //             } else if (~line.indexOf("c=")) {       // http://tools.ietf.org/html/rfc4566#section-5.7
        //                 var parts = line.split(' '),
        //                     addr = parts[2];
        //                 updateDisplay(addr);
        //             }
        //         });
        //     }
        // })(); else {
        //     var ip = "<code>ifconfig | grep inet | grep -v inet6 | cut -d\" \" -f2 | tail -n1</code>";
        //     //document.getElementById('list').innerHTML = "<code>ifconfig | grep inet | grep -v inet6 | cut -d\" \" -f2 | tail -n1</code>";
        // }

        return sessionStorage.getItem("clientIP");
    }

    DateToDB(sdate: any, time?: any) {
        if (sdate != null && sdate != '') {
            var res = sdate.split('/');
            var year = parseInt(res[2]);
            if (year > 2500) {
                year = year - 543;
            }
            if (time == '' || time == null) {
                time = "00:00:00";
            }
            return year + '-' + res[1] + '-' + res[0] + ' ' + time;
        } else {
            return sdate;
        }
    }
    ConvertToAD(buddistDate: any) {
        if (buddistDate != null && buddistDate != '') {
            var res = buddistDate.split('/');
            var year = parseInt(res[2]);
            if (year > 2400) {
                year = year - 543;
            }
            if (res[0].length == 1) {
                res[0] = '0' + res[0];
            }
            if (res[1].length == 1) {
                res[1] = '0' + res[1];
            }
            return res[0] + '/' + res[1] + '/' + year;
        } else {
            return buddistDate;
        }
    }

    ConvertToBE(buddistDate: any) {
        if (buddistDate != null && buddistDate != '') {
            var res = buddistDate.split('/');
            var year = parseInt(res[2]);
            if (year < 2500) {
                year = year + 543;
            }
            if (res[0].length == 1) {
                res[0] = '0' + res[0];
            }
            if (res[1].length == 1) {
                res[1] = '0' + res[1];
            }
            return res[0] + '/' + res[1] + '/' + year;
        } else {
            return buddistDate;
        }
    }

    DisPlayDate(DateStr: string) {
        if (DateStr != null && DateStr != '') {
            if (this.GetLanguage() == 'th-TH') {
                var x = DateStr.substring(0, 10);
                var t = DateStr.substring(10, DateStr.length);
                x = this.ConvertToBE(x);
                return x + t;
            } else {
                return DateStr;
            }
        } else {
            return DateStr;
        }
    }

    DisPlayDateWithOutTime(DateStr: string) {
        if (DateStr != null && DateStr != '') {
            if (this.GetLanguage() == 'th-TH') {
                var x = DateStr.substring(0, 10);

                x = this.ConvertToBE(x);
                console.log(x);
                return x;
            } else {
                var x = DateStr.substring(0, 10);

                x = this.ConvertToBE(x);
                console.log(x);
                return x;
            }
        } else {
            return DateStr;
        }
    }

    ShowWaiting(loading: boolean) {
        if (loading) {
            $('#waitingDialog').modal({
                backdrop: 'static',
                keyboard: false
            });
        }
        else {
            console.log('hide waiting');
            // $('#waitingDialog').modal('hide');

            setTimeout(function () { $('#btnCloseWaiting').click(); }, 500);
        }
    }
    GetCurrIP() {
        var clientIP = sessionStorage.getItem('clientIP');
        return clientIP;
    }

    GetLanguage() {
        return this.i18nService.language;
    }

    GetSiteMap() {
        return "";
        // return $('#divSiteMap').html();
    }

    SetSiteMap(x: any) {
        //$('#divSiteMap').html(x);
    }

    GetUserID() {
        var member_info: any = JSON.parse(sessionStorage.getItem('member_obj'));
        if (member_info != null) {
            return member_info.member_no;
        }
    }
    InitBranch(isAll: any, idSelect: any) {
        var member_info: any = JSON.parse(sessionStorage.getItem('member_obj'));
        if (member_info != null) {
            if (isAll) {
                this.InitDropdownAll(member_info.listBranch, idSelect);
            } else {
                this.InitDropdown(member_info.listBranch, idSelect);
            }
        }
    }

    async InitDropdown(obj: any, idSelect: any) {
        $('#' + idSelect).find('option').remove().end();
        if (obj != null) {
            if (obj.length > 0) {
                const select = document.getElementById(idSelect);
                const opt = document.createElement('option');
                opt.value = '';
                opt.innerHTML = 'เลือก';
                opt.selected = true;
                select.appendChild(opt);
                for (let i = 0; i < obj.length; i++) {
                    const opt2 = document.createElement('option');
                    opt2.value = obj[i].ddl_value;
                    opt2.innerHTML = obj[i].ddl_text;

                    select.appendChild(opt2);
                }

            }
        }
    }

    async InitDropdownAll(obj: any, idSelect: any) {
        $('#' + idSelect).find('option').remove().end();
        const select = document.getElementById(idSelect);
        const opt = document.createElement('option');
        opt.value = ''
        if (this.GetLanguage() == 'en-US') {
            opt.innerHTML = 'All'
        } else {
            opt.innerHTML = 'ทั้งหมด'
        }
        select.appendChild(opt);
        if (obj != null) {
            if (obj.length > 0) {
                for (let i = 0; i < obj.length; i++) {
                    const opt = document.createElement('option');
                    opt.value = obj[i].ddl_value;
                    opt.innerHTML = obj[i].ddl_text;
                    if (i == 0) {
                        opt.selected = true;
                    }
                    select.appendChild(opt);
                }


            }
        }
        $("select#" + idSelect)[0].selectedIndex = 0;
    }

    GetStartCurrentDate() {
        var d = new Date();

        var mont = d.getMonth();
        var day = d.getDate();
        var dayStr = '' + day;
        var monStr = '' + mont;
        var year = d.getFullYear();
        var yearStr = '' + d.getFullYear();

        if (day < 10) {
            dayStr = '0' + day;
        }
        if (mont < 10) {
            monStr = '0' + mont;
        }
        if (year > 2500) {
            yearStr = (year - 543) + '';
        }

        var d2 = new Date(parseInt(yearStr), mont, 1);
        return d2;
    }

    GetEndCurrentDate() {
        var d = new Date();

        var mont = d.getMonth() + 1;
        var day = d.getDate();
        var dayStr = '' + day;
        var monStr = '' + mont;
        var year = d.getFullYear();
        var yearStr = '' + d.getFullYear();

        if (day < 10) {
            dayStr = '0' + day;
        }
        if (mont < 10) {
            monStr = '0' + mont;
        }
        if (year > 2500) {
            yearStr = (year - 543) + '';
        }

        var d2 = new Date(parseInt(yearStr), mont, 0);
        return d2;
    }

    GetStartCurrentDateYear() {
        var d = new Date();

        var mont = d.getMonth();
        var day = d.getDate();
        var dayStr = '' + day;
        var monStr = '' + mont;
        var year = d.getFullYear();
        var yearStr = '' + d.getFullYear();

        if (day < 10) {
            dayStr = '0' + day;
        }
        if (mont < 10) {
            monStr = '0' + mont;
        }
        if (year > 2500) {
            yearStr = (year - 543) + '';
        }

        var d2 = new Date(parseInt(yearStr), 0, 1);
        return d2;
    }

    GetEndCurrentDateYear() {
        var d = new Date();

        var mont = d.getMonth() + 1;
        var day = d.getDate();
        var dayStr = '' + day;
        var monStr = '' + mont;
        var year = d.getFullYear();
        var yearStr = '' + d.getFullYear();

        if (day < 10) {
            dayStr = '0' + day;
        }
        if (mont < 10) {
            monStr = '0' + mont;
        }
        if (year > 2500) {
            yearStr = (year - 543) + '';
        }

        var d2 = new Date(parseInt(yearStr), 11, 31);
        return d2;
    }

    checkTime(i: any) {
        if (i < 10) { i = "0" + i };  // add zero in front of numbers < 10
        return i;
    }
    checkTime2(i: any) {
        if (i < 100) { i = "0" + i };
        return i;
    }

    TableExcelReport(id: any, filename: any, coldis?: any, colName?: any, coldis2?: any, coldis3?: any, coldis4?: any, coldis5?: any, coldis6?: any) {
        var table = $('#' + id).DataTable();
        var form_data = table.rows().data();

        console.log('form_data', table.columns().context[0].aoColumns[0].data);
        if (form_data != null) {
            if (form_data.length > 0) {
                //So, to get all data do:
                if (coldis == null) {
                    coldis = -1;
                }
                if (coldis2 == null) {
                    coldis2 = -1;
                }
                if (coldis3 == null) {
                    coldis3 = -1;
                }
                if (coldis4 == null) {
                    coldis4 = -1;
                }
                if (coldis5 == null) {
                    coldis5 = -1;
                }
                if (coldis6 == null) {
                    coldis6 = -1;
                }


                //console.log('form_data', form_data);
                var nRow = $('#' + id + ' thead tr')[0];

                var tab_text = '<table border="1" ><tr>';

                $.each(nRow.cells, function (i: any, v: any) {
                    if (i != coldis && i != coldis2 && i != coldis3 && i != coldis4 && i != coldis5 && i != coldis6) {
                        tab_text += "<td>" + v.innerHTML + "</td>";

                    }


                });
                if (colName != null && colName != '') {
                    tab_text += "<td>" + colName + "</td>";
                }
                tab_text += "</tr>";

                for (var i = 0; i < form_data.length; i++) {
                    tab_text += "<tr>";
                    for (var j = 0; j < table.columns().context[0].aoColumns.length; j++) {
                        if (j != coldis && j != coldis2 && j != coldis3 && j != coldis4 && j != coldis5 && j != coldis6) {
                            if (form_data[i][table.columns().context[0].aoColumns[j].data] == null) {
                                tab_text += "<td></td>";
                            } else {
                                tab_text += "<td style='mso-number-format:\\@'>" + form_data[i][table.columns().context[0].aoColumns[j].data] + "</td>";
                            }

                        }
                    }
                    tab_text += "</tr>";
                }


                // var textRange; var j = 0;
                // var tab: any = document.getElementById(id); // id of table

                // for (j = 0; j < tab.rows.length; j++) {
                //     tab_text = tab_text + tab.rows[j].innerHTML + "</tr>";
                //     //tab_text=tab_text+"</tr>";
                // }

                tab_text = tab_text + "</table>";
                tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
                tab_text = tab_text.replace(/<img[^>]*>/gi, ""); // remove if u want images in your table
                tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params

                var ua = window.navigator.userAgent;
                var msie = ua.indexOf("MSIE ");

                /* if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer
                 {
                   txtArea1.document.open("txt/html", "replace");
                   txtArea1.document.write(tab_text);
                   txtArea1.document.close();
                   txtArea1.focus();
                   sa = txtArea1.document.execCommand("SaveAs", true, "Say Thanks to Sumit.xls");
                 }
                 else                 //other browser not tested on IE 11*/
                //var sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));

                var downloadLink;
                var dataType = 'application/vnd.ms-excel';
                // var tableSelect = document.getElementById(id);
                var tableHTML = tab_text.replace(/ /g, '%20');// tableSelect.outerHTML.replace(/ /g, '%20');

                // Specify file name
                filename = filename ? filename + this.GetCurrentDate() + '.xls' : 'excel_data.xls';

                // Create download link element
                downloadLink = document.createElement("a");

                document.body.appendChild(downloadLink);

                if (navigator.msSaveOrOpenBlob) {
                    var blob = new Blob(['\ufeff', tableHTML], {
                        type: dataType
                    });
                    navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // Create a link to the file
                    downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

                    // Setting the file name
                    downloadLink.download = filename;

                    //triggering the function
                    downloadLink.click();
                }

                //return (sa);
            } else {
                this.ErrorDialog('ไม่พบข้อมูล');
            }
        } else {
            this.ErrorDialog('ไม่พบข้อมูล');
        }
    }

    GetMonthNames(x: any) {
        var str = '';
        if (x == '01' || x == '1') {
            str = 'มกราคม';
        }
        if (x == '02' || x == '2') {
            str = 'กุมภาพันธ์';
        }
        if (x == '03' || x == '3') {
            str = 'มีนาคม';
        }
        if (x == '04' || x == '4') {
            str = 'เมษายน';
        }
        if (x == '05' || x == '5') {
            str = 'พฤษภาคม';
        }
        if (x == '06' || x == '6') {
            str = 'มิถุนายน';
        }
        if (x == '07' || x == '7') {
            str = 'กรกฎาคม';
        }
        if (x == '08' || x == '8') {
            str = 'สิงหาคม';
        }
        if (x == '09' || x == '9') {
            str = 'กันยายน';
        }
        if (x == '10' || x == '10') {
            str = 'ตุลาคม';
        }
        if (x == '11' || x == '11') {
            str = 'พฤศจิกายน';
        }
        if (x == '12' || x == '12') {
            str = 'ธันวาคม';
        }

        return str;
    }

    GetCurrentDate() {
        var d = new Date();

        var mont = d.getMonth() + 1;
        var day = d.getDate();
        var dayStr = '' + day;
        var monStr = '' + mont;
        var year = d.getFullYear();
        var yearStr = '' + d.getFullYear();

        if (day < 10) {
            dayStr = '0' + day;
        }
        if (mont < 10) {
            monStr = '0' + mont;
        }

        return yearStr + '' + monStr + '' + dayStr;
    }

    async ValidateSelectedDocument(Selected: any, DocGroup: any) {
        if (Selected == null || Selected == undefined || Selected.length == 0) {
            this.WarningDialog("กรุณาเลือกประเภทเอกสาร");
            return false;
        }
        var ItemFound: boolean;
        var IsValid = true;
        var Msg = "", Msg2 = "";
        DocGroup.forEach((DocList: any) => {
            ItemFound = false;
            Msg2 = "";
            // DocList.dpa_documentlist.forEach((Doc: any) => {
            //     Selected.forEach((a: any) => {
            //         if (a.dpa_documentid == Doc.dpa_documentid) {
            //             ItemFound = true;
            //         }
            //     });
            //     Msg2 += (Msg2 == "" ? "" : " หรือ ") + Doc.dpa_name;
            // });
            Selected.forEach((a: any) => {
                if (a.dpa_documentid == DocList.dpa_documentgroupid) {
                    ItemFound = true;
                }
            });
            Msg2 = DocList.dpa_name;

            if (!ItemFound) {
                IsValid = false;
                Msg += (Msg == "" ? "" : " และ ") + Msg2;
            }
        });
        if (!IsValid)
            this.WarningDialog("กรุณาเลือก" + Msg);
        return IsValid;
    }

    ValidateCitizenID(IDCardNo: any) {
        /*if (IDCardNo.length != 13)
            return false;
        for (var i = 0, Sum = 0; i < 12; i++) {
            if (isNaN(IDCardNo.charAt(i)))
                return false;
            Sum += parseFloat(IDCardNo.charAt(i)) * (13 - i);
        }
        if (isNaN(IDCardNo.charAt(12)))
            return false;
        if ((11 - Sum % 11) % 10 != parseFloat(IDCardNo.charAt(12)))
            return false;*/
        return true;
    }

    isSuccessResponse(res: any) {
        if(res != null && res["status"] != null){
          return res["status"] >= 200 && res["status"] < 300
        }
        else{
          return res != null
        }
        // return (res != null && res["status"] != null && res["status"] >= 200 && res["status"] < 300) || res.RESMSG == "SUCCESS"
        // return res != null || (res != null && res.RESMSG == "SUCCESS")
      }

    CreateBlobUrl(Base64Url: any) {
        const Base64Data = Base64Url.split(",")[1];
        const ContentType = Base64Url.substring(Base64Url.indexOf(":") + 1, Base64Url.indexOf(";"))
        const ByteCharacters = atob(Base64Data);
        const ByteArrays = [];
        for (let offset = 0; offset < ByteCharacters.length; offset += 512) {
            const slice = ByteCharacters.slice(offset, offset + 512);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            ByteArrays.push(byteArray);
        }

        const blob = new Blob(ByteArrays, { type: ContentType });
        return URL.createObjectURL(blob);
    }

    baseUrlNoPort() {
        //return window.location.protocol + "//" + window.location.hostname
        return environment.apiProtocol + "//" + window.location.hostname
      }

      baseUrl() {
        return window.location.protocol + "//" + window.location.hostname + (window.location.port != "" ? ":" + window.location.port : "")
      }
}



// WEBPACK FOOTER //
// ./src/app/utility/util.service.ts